module.exports = __webpack_public_path__ + "img/ten-years.630664b2.svg";